export { default } from "./BGIcon";
